export interface FileTypeInfo {
  extension: string;
  cssClass: string;
}

export const SupportedFileTypes: FileTypeInfo[] = [
  { extension: '.pdf', cssClass: 'bi-filetype-pdf' },
  { extension: '.docx', cssClass: 'bi-filetype-docx' },
  { extension: '.doc', cssClass: 'bi-filetype-doc' },
  //{ extension: '.rtf', cssClass: 'bi-file-earmark-text' },
];
